const CURRENCY_CODE = 'VNĐ';

const CURRENCY_SYMBOL = 'đ';

export {
    CURRENCY_CODE,
    CURRENCY_SYMBOL,
}
